import { observer } from 'mobx-react';
import { useKeycloakStore } from '../../store';
import { Button, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from '../../sharedStyles/Layout.module.css';
import { MyIcon } from '@web/common-ui';

export const LogoutButton = observer(() => {
  const kc = useKeycloakStore();
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      w="100%"
      fw="400"
      onClick={() => kc.logout()}
      maw="200px"
    >
      <Text w="100%" size="16px" lh="18px" ta="center">
        {t('Buttons.LOGOUT')}
      </Text>
    </Button>
  );
});

export const LogoutButtonWithIcon = observer(
  ({ smallIcon }: { smallIcon: boolean }) => {
    const kc = useKeycloakStore();
    const { t } = useTranslation();

    return (
      <Button
        className={classes.button}
        variant={smallIcon ? 'outline' : 'white'}
        justify="flex-start"
        size="lg"
        leftSection={<MyIcon name={'logout'} className={classes.icon} />}
        onClick={() => kc.logout()}
      >
        <Text className={classes.navBtnText}>{t('Buttons.Logout')}</Text>
      </Button>
    );
  },
);
